export const changeWardNameReducer = (state = "AlFaw", action) => {
    switch (action.type) {
      case "CHANGE_WARD_NAME":
        return action.payload.wardName;
      default:
        return state;
    }
};